<template>
  <v-container grid-list-xl>
    <h1 class="pl-4">
      <span>Professional Games</span>
      <!-- <span class="green--text">Portfolio</span> -->
    </h1>

    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="game.dialog"
        lazy
        max-width="800"
        v-for="game in proProject"
        :key="game.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="game.poster"
                aspect-ratio="1.7778"
                :alt="game.title"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{game.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="game.dialog">
          <v-card-title class="cardTitle">
            {{game.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="game.link">{{game.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{game.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Demo</h3>
          </v-card-text>
          <v-card-media v-if="game.demo">
            <div class="iframe-wrapper">
              <iframe :src="game.href" allowfullscreen allowtransparency allow="autoplay" ></iframe>
            </div>
          </v-card-media>
          <v-card-media v-if="!game.demo">
            <v-img contain max-height="500px" :src="game.poster"></v-img>
          </v-card-media>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Technology</span>
              <span class="right" >Role</span>
            </h3>
            <v-chip color="green" text-color="white">{{game.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{game.tech.tech2}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{game.role}}</v-chip>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-divider
      :thickness="6"
      class="border-opacity-50 mt-5 mb-5"
      color="success"
    ></v-divider>

    <h1 class="pl-4">
      <span>Personal Projects</span>
      <!-- <span class="green--text">Portfolio</span> -->
    </h1>
    <h2 class="pl-4">
      More on my <b><a href="https://mathxxl.itch.io/">itch.io</a></b> page.
    </h2>

    <v-layout row justify-center align-center wrap class="mt-4 pt-2">

      <v-dialog
        v-model="game.dialog"
        lazy
        max-width="800"
        v-for="game in project"
        :key="game.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="game.poster"
                aspect-ratio="1.7778"
                :alt="game.title"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{game.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="game.dialog">
          <v-card-title class="cardTitle">
            {{game.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="game.link">{{game.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
              <p>{{game.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Demo</h3>
          </v-card-text>
          <v-card-media v-if="game.demo">
            <div class="iframe-wrapper">
                <iframe :src="game.href" allowfullscreen allowtransparency allow="autoplay" ></iframe>
            </div>
          </v-card-media>
          <v-card-media v-if="!game.demo">
            <v-img contain max-height="500px" :src="game.poster"></v-img>
          </v-card-media>
          <v-card-text>
              <h3 class="headline mb-0">
                <span>Technology</span>
                <span class="right" >Role</span>
              </h3>
              <v-chip color="green" text-color="white">{{game.tech.tech1}}</v-chip>
              <v-chip color="green" text-color="white">{{game.tech.tech2}}</v-chip>
              <v-chip class="right" color="green" text-color="white">{{game.role}}</v-chip>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-divider
      :thickness="6"
      class="border-opacity-50 mt-5 mb-5"
      color="success"
    ></v-divider>

    <h1 class="pl-4">
      <span>School Projects</span>
      <!-- <span class="green--text">Portfolio</span> -->
    </h1>

    <v-layout row justify-center align-center wrap class="mt-4 pt-2">

      <v-dialog
        v-model="game.dialog"
        lazy
        max-width="800"
        v-for="game in school"
        :key="game.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="game.poster"
                aspect-ratio="1.7778"
                :alt="game.title"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{game.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="game.dialog">
          <v-card-title class="cardTitle">
            {{game.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="game.link">{{game.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{game.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Demo</h3>
          </v-card-text>
          <v-card-media v-if="game.demo">
            <div class="iframe-wrapper">
              <iframe :src="game.href" allowfullscreen allowtransparency allow="autoplay" ></iframe>
            </div>
          </v-card-media>
          <v-card-media v-if="!game.demo">
            <v-img contain max-height="500px" :src="game.poster"></v-img>
          </v-card-media>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Technology</span>
              <span class="right" >Role</span>
            </h3>
            <v-chip color="green" text-color="white">{{game.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{game.tech.tech2}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{game.role}}</v-chip>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

  </v-container>
</template>

<script>

export default {
  metaInfo: {
    title: 'Games Portfolio ',
    titleTemplate: "%s ← Mathieu's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          'Mathieu Baesen games portfolio'
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Mathieu' Space" },
      { property: 'og:site_name', content: "Mathieu' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://Mathieu.space' },
      {
        property: 'og:description',
        content:
          'Mathieu Baesen games portfolio'
      }
    ]
  },

  data () {
    return {
      dialog: false,
      proProject: [
        {
          dialog: false,
          title: 'Sprint Racers',
          poster: 'https://www.sportypeppers.com/medias/1/16/m/_01T1.webp',
          demo: true,
          href: 'https://www.youtube.com/embed/dRICKGWegdw',
          description: 'Courez, baissez-vous et sautez pour faire le meilleur temps possible et arriver 1er à la fin de la course ! \n' +
            'Le jeu Sprint Racers qui est entièrement paramétrable en difficulté, intensité de mouvement, obstacles et durée. Il a bénéficié du soutien de la Région Ile-De-France et de BPI dans le cadre de Innov’up Bien vieillir. \n' +
            '\n' +
            'Courrez, sautez, ou baissez-vous pour être le plus rapide ! ',
          link: 'https://www.sportypeppers.com/jeux/sprint-racers',
          role: 'Gameplay Developer, Backend Developer',
          tech: {
            tech1: 'Unity',
            tech2: 'Tensorflow'
          }
        }, {
          dialog: false,
          title: 'Swim Racers',
          poster: 'https://www.sportypeppers.com/medias/1/121/m/swim-racers_03T1.webp',
          demo: true,
          href: 'https://www.youtube.com/embed/JluddyA4QIc',
          description: 'Idéal pour bouger sans contrainte et dans la bonne humeur ! Faites le meilleur temps possible en enchaînant les mouvements de crawl pour atteindre la fin du bassin avant vos adversaires.\n' +
            '\n' +
            'Un jeu accessible à tous, 100 % haut du corps. Swim Racers est un jeu inclusif, conçu pour s’adapter à tous les publics et encourager la mise en mouvement, tout en gardant l\'esprit compétitif !\n' +
            '\n' +
            'Prêt(e) à remporter la médaille d’or ? À vos marques, prêts… nagez !',
          link: 'https://www.sportypeppers.com/jeux/swim-racers',
          role: 'Developer, Backend Developer',
          tech: {
            tech1: 'Unity',
            tech2: 'Tensorflow'
          }
        }, {
          dialog: false,
          title: 'Juga Ball',
          poster: 'https://www.sportypeppers.com/medias/1/17/m/juga-ball_03T1.webp',
          demo: true,
          href: 'https://www.youtube.com/embed/XPTEim6JN1k',
          description: 'Faites le plus de jongles possibles ! Enchaînez le plus de combos pour réaliser le meilleur score.',
          link: 'https://www.sportypeppers.com/jeux/juga-ball',
          role: 'Gameplay Developer, Backend Developer',
          tech: {
            tech1: 'Unity',
            tech2: 'Tensorflow'
          }
        }
      ],
      project: [
        {
          dialog: false,
          title: 'OOR-T Station',
          poster: 'https://img.itch.zone/aW1nLzI2NDE2MjQxLnBuZw==/315x250%23c/LlLZVF.png',
          demo: false,
          href: 'https://youtube.com/embed/_SrKwK87QSE',
          description: 'Grace is a student working on a remote space station where nothing happens... most of the time! During her last 3 days, she\'ll encounter several people, each one stranger than the next, and maybe uncover some kind of hidden plot... Developed for NaNoRenO 2026 using Naninovel.',
          link: 'https://mathxxl.itch.io/oor-t-station',
          role: 'Lead Narrative Designer, Developer',
          tech: {
            tech1: 'Unity',
            tech2: 'NaniNovel'
          }
        },
        {
          dialog: false,
          title: 'Mahou Shoujo Space Girl Elena',
          poster: 'https://img.itch.zone/aW1nLzIwNDk2MzUzLnBuZw==/315x250%23c/j0KUAg.png',
          demo: false,
          href: 'https://youtube.com/embed/_SrKwK87QSE',
          description: 'Magical Girl is an average Magical Girl working in a space station. Asked to bring a powerful artifact to the border of the galaxy, she\'ll encounter there a team of Magical Girls, face a terrible enemy, and maybe even find love???',
          link: 'https://mathxxl.itch.io/magical-girls-sf-horror-romance',
          role: 'Unity Developer, Narrative Writer',
          tech: {
            tech1: 'Unity',
            tech2: 'NaniNovel'
          }
        },
        {
          dialog: false,
          title: 'Roots of Ceres',
          poster: 'https://img.itch.zone/aW1nLzExMjMwNTI2LnBuZw==/315x250%23c/n%2Fq%2BY8.png',
          demo: true,
          href: 'https://youtube.com/embed/_SrKwK87QSE',
          description: 'Manage the roots of a tree in this fun fast-paced game in order to grow into a majestic one ! ' + 'Made during the Global Game Jam 2023 by a team of 2 developers.',
          link: 'https://mathxxl.itch.io/roots-of-ceres',
          role: 'Unity Developer, Music Composer, Game Designer',
          tech: {
            tech1: 'Unity',
            tech2: '2D'
          }
        }, {
          dialog: false,
          title: 'Le Dernier Exode',
          poster: 'https://img.itch.zone/aW1nLzEwNzYzMDEzLmpwZw==/315x250%23c/MeH8jC.jpg',
          demo: true,
          href: 'https://www.youtube.com/embed/x-r3R1TWStU',
          description: 'L’histoire de notre jeu démarre vers l’an 54 210. La Terre a épuisé ses ressources naturelles, et il ne reste qu’un groupe de survivants humains dans un environnement hostile. Se pensant condamnés, ils finissent par trouver enfoui sous une montagne un immense vaisseau spatial, caché depuis des milliers d’années. Celui-ci est endormi mais fonctionne encore, les survivants font donc le choix d’en faire leur nouveau foyer et de quitter la planète. Le vaisseau est âgé, il leur faudra donc petit à petit l’explorer et y construire tout le nécessaire mais également faire face aux différents dangers de l’espace.',
          link: 'https://fromiel.itch.io/le-dernier-exode',
          role: 'Unity Developer, Music Composer',
          tech: {
            tech1: 'UNITY',
            tech2: '3D'
          }
        },
        {
          dialog: false,
          title: 'Trader Runner',
          poster: 'https://img.itch.zone/aW1nLzEwNTY5ODAxLnBuZw==/original/bMq80L.png',
          demo: true,
          href: "https://youtube.com/embed/ZT6KAELQvwk", //'https://img.itch.zone/aW1hZ2UvMTc5ODMxMy8xMDU3MTM3NS5wbmc=/794x1000/TzvQiy.png',
          description: '[Submission for Unijam 2022] Distance gives you the power of colors ! Dans cet endless runner tout en couleur, vous incarnez un blob qui traverse différents mondes chacun dans une teinte différente. Récupérez les ressources de chaque zone et vendez-les le plus loin possible afin de gagner le maximum de score ! Mais attention à ne pas vous faire avoir par un obstacle...',
          link: 'https://mathxxl.itch.io/trader-runner',
          role: 'Unity Developer, Music Composer',
          tech: {
            tech1: 'UNITY',
            tech2: '2D'
          }
        },
        {
          dialog: false,
          title: 'Étiolles\' Traveler',
          poster: 'https://img.itch.zone/aW1nLzEwMjM5MTExLnBuZw==/315x250%23c/668QBm.png',
          demo: true,
          href: 'https://youtube.com/embed/gC-6ci2O8os',
          description: 'Étiolles\' Traveler est un jeu de survival action où le joueur doit se battre avec différentes armes contre la faune locale et commercer avec les Magdaléniens pour améliorer son équipement, le tout sous fond de références historiques précises.',
          link: 'https://itch.io/jam/etiolles2022/rate/1739260',
          role: 'Unity Developper, Music Composer',
          tech: {
            tech1: 'UNITY',
            tech2: '2D'
          }
        },
        {
          dialog: false,
          title: 'The Fireflies Express',
          poster: 'https://i.imgur.com/pqxqFIL.png',
          demo: true,
          href: 'https://youtube.com/embed/KYu0GYQfNEE',
          description: 'Face the dangers of an eerie train with the help of an angel and a demon, and try to reach the exit !' +
            ' Game made during the Global Game Jam 2022 by a team of 6. 2 graphic designer, 3 developers and 1 game designer',
          link: 'https://globalgamejam.org/2022/games/fireflies-express-1',
          role: 'Unity Developper, Music Composer',
          tech: {
            tech1: 'UNITY',
            tech2: '2D'
          }
        },
        {
          dialog: false,
          title: 'Brocante et Coeurs Brisés',
          poster: 'https://img.itch.zone/aW1nLzc0Mzc5NzIucG5n/original/gT15xm.png',
          demo: true,
          href: 'https://img.itch.zone/aW1nLzc0MzI4NjIucG5n/original/pGRyoC.png',
          description: 'Vous êtes un brocanteur au fin fond de l’Alsace-Lorraine. Hélas, si la vie n’était pas trop dur avec votre femme et vos deux enfants, votre père vient de tomber très malade. Vous êtes dans une course contre la montre pour gagner suffisamment d’argent pour le sauver.\n' +
            'Vendez vos objets aux passants de ce village perdu mais prenez garde : votre réputation de brocanteur pourrait pâtir de vos actions.',
          link: 'https://biscuitprime.itch.io/brocante-coeurs-brises',
          role: 'Unity Developper',
          tech: {
            tech1: 'UNITY',
            tech2: '2D/3D'
          }
        },
        {
          dialog: false,
          title: 'Aux Confins du Monde',
          poster: 'https://img.itch.zone/aW1nLzY2MDU2NzYuanBn/315x250%23c/y5ByQ0.jpg',
          demo: true,
          href: 'https://www.youtube.com/embed/xdFi7ld--m8',
          description: 'A 3D-exploration game which offers a lot of liberty to the player to explore the world, with only one goal : reach the end of the world !',
          link: 'https://magiasunheat.itch.io/aux-confins-du-monde',
          role: 'Unity Developper, Music Composer, Game Designer',
          tech: {
            tech1: 'UNITY',
            tech2: '3D'
          }
        }
      ],
      school: [{
        dialog: false,
        title: 'Higashikata',
        poster: 'https://img.itch.zone/aW1nLzEwNDMyOTAzLmpwZw==/315x250%23c/%2Fqfd75.jpg',
        demo: true,
        description: 'Shooter de type Bullet Hell inspiré de la célèbre franchise Touhou Project.',
        href: 'https://youtube.com/embed/8YeNXyrNjO8',
        link: 'https://mathxxl.itch.io/higashikata',
        role: 'Unity Developer, Music Composer',
        tech: {
          tech1: 'UNITY',
          tech2: '3D'
        }
      },{
        dialog: false,
        title: 'A Christmas Carnage',
        poster: 'https://i.imgur.com/MY4nIu6.png',
        demo: true,
        href: 'https://youtube.com/embed/9H2mbBLPEwA',
        description: 'Triomphez des forces de Noël dans ce Tower Defense où pour une fois le Père Noël n\'est pas votre ami !',
        link: '',
        role: 'Unity Developper, Music Composer',
        tech: {
          tech1: 'UNITY',
          tech2: '3D'
        }
      }]
    }
  }
}
</script>

<style  scoped>

.cardTitle{
  text-align: center;
  color: green ;
  font-size: x-large;
  justify-content: center;
}

.iframe-wrapper {
  position: relative;
  height: 0;
  padding-top: 56.25%;
  overflow: hidden;
  margin: 3%;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>
